var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgShieldCross(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 22,
    viewBox: "0 0 18 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.783 1.826L9 0L17.217 1.826C17.4391 1.87536 17.6377 1.99897 17.78 2.1764C17.9224 2.35384 18 2.57452 18 2.802V12.789C17.9999 13.7767 17.756 14.7492 17.2899 15.62C16.8238 16.4908 16.1499 17.2331 15.328 17.781L9 22L2.672 17.781C1.85027 17.2332 1.17646 16.4911 0.710348 15.6205C0.244236 14.7498 0.000236356 13.7776 0 12.79V2.802C3.90378e-05 2.57452 0.0776379 2.35384 0.21999 2.1764C0.362341 1.99897 0.560937 1.87536 0.783 1.826ZM2 3.604V12.789C2.00001 13.4475 2.16257 14.0957 2.47326 14.6763C2.78395 15.2568 3.23315 15.7517 3.781 16.117L9 19.597L14.219 16.117C14.7667 15.7518 15.2158 15.2571 15.5265 14.6767C15.8372 14.0964 15.9998 13.4483 16 12.79V3.604L9 2.05L2 3.604Z",
    fill: "#EB5757"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.47029 6.46981C5.7632 6.17693 6.23807 6.17695 6.53095 6.46986L12.5303 12.4697C12.8232 12.7626 12.8232 13.2375 12.5303 13.5304C12.2374 13.8233 11.7625 13.8233 11.4696 13.5304L5.47025 7.53047C5.17737 7.23757 5.17739 6.76269 5.47029 6.46981Z",
    fill: "#EB5757"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.5303 6.46968C12.8232 6.76259 12.8232 7.23746 12.5303 7.53034L6.52966 13.5305C6.23676 13.8233 5.76188 13.8233 5.469 13.5304C5.17612 13.2375 5.17614 12.7626 5.46904 12.4698L11.4696 6.46964C11.7626 6.17676 12.2374 6.17678 12.5303 6.46968Z",
    fill: "#EB5757"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShieldCross);
export default __webpack_public_path__ + "static/media/shield-cross.fee694054c244e35c45d0be50958df6e.svg";
export { ForwardRef as ReactComponent };